<!-- THIS IS A TEMPLATE TO COPY AND PASTE -->
<div style="width: 740px; height: 800px;" data-cy="diagnosis-lymphadenopathy-container">
  <div class="section" style="display: flex; flex-direction: column; height: 100%; max-height: 100%;" data-cy="diagnosis-lymphadenopathy-section">
    <div class="section-header" style="flex-basis: 30px;" data-cy="diagnosis-lymphadenopathy-header">
      <div class="section-header-title" data-cy="diagnosis-lymphadenopathy-title">
        Lymphadenopathy
      </div>
      <div style="flex: 1;"></div>
    </div>
    <!--  MAIN AREA-->
    <div class="section-content" style="flex: 1;" data-cy="diagnosis-lymphadenopathy-content">
      <img style="height: 100%; width: 100%;" src="assets/dialogs/lympha/BBJ8BM.jpg" data-cy="diagnosis-lymphadenopathy-image" />
    </div>
    <!--  FOOTER-->
    <div class="section-footer" style="flex-basis: 46px; padding-top: 6px;" data-cy="diagnosis-lymphadenopathy-footer">
      <div style="flex: 1; margin-right: 6px;"></div>
      <button (click)="onOkClick()" class="tdo-button tdo-save" style="margin-right: 6px;" data-cy="diagnosis-lymphadenopathy-ok-button">Ok</button>
    </div>
  </div>
</div>
